// function positionToEdgeImage() {
//     let containerReference = $('.container').first(),
//         containerWidth = containerReference.width(),
//         containerOffset = containerReference.offset().left;
//
//     $('.offset-to-edge').each(function () {
//         $(this).parent('figure').css({
//             'margin-right': 0 - containerOffset - 25,
//         });
//     });
// }
//
// positionToEdgeImage();
// $(window).on('resize', positionToEdgeImage);

function containerPaddingMatchup() {
    let containerReference = $('.container').first(),
        wrapperReference = $('.wrapper').first(),
        containerWidth = containerReference.width();

    let containerOffset = (wrapperReference.outerWidth() - containerWidth) / 2;

    if($(window).width() > 991 ) {
        $('.container-padding-matchup').each(function () {
            if($(this).hasClass('left-padding')) $(this).css({'padding-left': containerOffset});
            if($(this).hasClass('right-padding')) $(this).css({'padding-right': containerOffset});
        });
    } else {
        $('.container-padding-matchup').each(function () {
            if($(this).hasClass('left-padding')) $(this).css({'padding-left': ''});
            if($(this).hasClass('right-padding')) $(this).css({'padding-right': ''});
        });
    }
}

containerPaddingMatchup();
$(window).on('resize', containerPaddingMatchup);
